var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.nbRows),function(row){return _c('div',{key:row,style:({ opacity: 1 - (row * 0.1) })},[_c('v-skeleton-loader',{staticClass:"border-bottom",attrs:{"type":"list-item"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }